/* GENERATED FILE */
import * as React from 'react';
import Svg, { Rect, Path } from 'react-native-svg';

import { IconProps } from '../lib';

function Flower(props: IconProps) {
  return (
    <Svg
      id="Raw"
      viewBox="0 0 256 256"
      width={props.size}
      height={props.size}
      {...props}
    >
      <Rect width={256} height={256} fill="none" />
      <Path d="M208.35352,132.82324A57.99826,57.99826,0,0,0,196.93994,128a58.016,58.016,0,0,0,11.41406-4.82324,36,36,0,1,0-36.00048-62.35352,58.00132,58.00132,0,0,0-9.88331,7.47266A58.01937,58.01937,0,0,0,164,56a36,36,0,0,0-72,0,58.01145,58.01145,0,0,0,1.52979,12.29541A58.01465,58.01465,0,0,0,83.646,60.82227a36.00017,36.00017,0,0,0-35.99952,62.35449A57.99826,57.99826,0,0,0,59.06006,128,58.016,58.016,0,0,0,47.646,132.82324a36,36,0,0,0,36.00048,62.35352,58.00132,58.00132,0,0,0,9.88331-7.47266A58.01937,58.01937,0,0,0,92,200a36,36,0,0,0,72,0,58.01145,58.01145,0,0,0-1.52979-12.29541,58.01465,58.01465,0,0,0,9.88379,7.47314,36.00017,36.00017,0,0,0,35.99952-62.35449ZM128,152a24,24,0,1,1,24-24A24.02687,24.02687,0,0,1,128,152Z" />
    </Svg>
  );
}

export default Flower;
